// import { Locale } from 'App/i18n' throws error we need to make a research the error
import { DomainTranslations } from 'App/i18n';
import { Locale } from 'App/i18n/enums';
import esAR from './partnersApps.es-AR.json';
import esMX from './partnersApps.es-MX.json';
import ptBR from './partnersApps.pt-BR.json';

const partnersAppsTranslations: DomainTranslations = {
  name: 'partnersApps',
  languages: {
    [Locale.ARGENTINA]: esAR,
    [Locale.MEXICO]: esMX,
    [Locale.BRAZIL]: ptBR,
  },
};

export default partnersAppsTranslations;
